import rest from "../script/rest";

class PlanRest {

    async getImageById(planId) {
        const url = "/rest/plan/getImageById"
            + "?planId=" + planId;
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }

    async setImageById(planId, base64Image){
        const url = "/rest/plan/setImageById";

        const base64ImageParts = base64Image.split(",");
        // eslint-disable-next-line
        const contentType = base64ImageParts[0].split(":")[1];
        const rawImageData = window.atob(base64ImageParts[1]);
        const imageDataArray = new Uint8Array(rawImageData.length);
        for (let i = 0; i < rawImageData.length; i++) {
            imageDataArray[i] = rawImageData.charCodeAt(i);
        }
        const imageBlob = new Blob([imageDataArray], { type: contentType });

        const formData = new FormData();
        formData.append("file", imageBlob);
        formData.append("planId", planId);
        const response = await rest.form(url, formData);
        return response;
    }
}
const planRest = new PlanRest();
window.planRest = planRest;
export default planRest;